import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const servicesMenu = css`
  max-inline-size: ${spacing(121)}; // 968px
  padding-inline-start: ${spacing(26.5)}; // 212px
`
export const otherBusinessesMenu = css`
  max-inline-size: ${spacing(110)}; // 880px
  padding-inline-start: ${spacing(37)}; // 296px
`
export const connectionMethodsMenu = css`
  padding-inline-start: ${spacing(65)}; // 520px
`
